export enum ContractStatusFormatted {
  AwaitingApproval = 'Awaiting Approval',
  Active = 'Active',
  Inactive = 'Inactive',
  ActiveDNR = 'Dnr',
  Expired = 'Expired',
  Cancelled = 'Cancelled',
  Terminating = 'Terminating',
  Terminated = 'Terminated',
  Merged = 'Merged'
}

export enum BillingTypeFormatted {
  Deposit = 'Deposit',
  Initials = 'Initials',
  Subscription = 'Subscription',
  Variable = 'Variable',
}
